import { useEffect, useState, useCallback } from 'react';
import { fetchGraphql } from '../graphql/fetch';

export interface QuotaState {
  remaining: number | null;
  resetAt:   string | null;
  refetch:   () => Promise<void>;
}

export function useQuota({ challengeSlug }: { challengeSlug: string }): QuotaState {
  const [remaining, setRemaining] = useState<number | null>(null);
  const [resetAt, setResetAt]     = useState<string | null>(null);

  const refetch = useCallback(async () => {
    const res = await fetchGraphql<{ challenge: { viewerSubmissionContext: { remaining: number | null; resetAt: string | null } | null } | null }>({
      query: `query Q($slug: ID!) {
        challenge(slug: $slug) {
          viewerSubmissionContext { remaining resetAt }
        }
      }`,
      variables: { slug: challengeSlug }
    });
    const ctx = (res && res.data && res.data.challenge && res.data.challenge.viewerSubmissionContext) || null;
    setRemaining(ctx && ctx.remaining != null ? ctx.remaining : null);
    setResetAt(ctx && ctx.resetAt != null ? ctx.resetAt : null);
  }, [challengeSlug]);

  useEffect(() => { refetch(); }, [refetch]);

  return { remaining, resetAt, refetch };
}
